import { render } from "./SlidesOriginalPreview.vue?vue&type=template&id=fa5e4622&scoped=true&ts=true"
import script from "./SlidesOriginalPreview.vue?vue&type=script&lang=ts"
export * from "./SlidesOriginalPreview.vue?vue&type=script&lang=ts"

import "./SlidesOriginalPreview.vue?vue&type=style&index=0&id=fa5e4622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa5e4622"]])

export default __exports__